import React from 'react';
import SegmentGrid from 'src/components/segment-cdt/SegmentGrid';
import { useHistory } from 'react-router-dom';
import { makeNameLinkColumn } from 'src/components/custom-tables-shared/TableNameLinkColumn';
import { SegmentTableListRow } from 'src/models/segment-cdt/SegmentTableListRow';

/**
 * Read-only grid for the Segment Data Tables list: Name (link) · Segment Type · Owner ·
 * Last Pull. Supplies the list's column defs + Name-link navigation and renders them through the
 * shared `SegmentGrid` (which the detail data-viewer also uses). The reusable Name-link cell comes
 * from `makeNameLinkColumn`. `SegmentGrid`/`TPEReactTable` render the loading + empty states.
 */
export default function SegmentTablesGrid(props: { loading: boolean, tables: SegmentTableListRow[], tableDetailUrl: string }) {
    const { loading, tables = [], tableDetailUrl } = props;
    const history = useHistory();

    // A plain push, carrying no breadcrumb state, so the detail page takes its trail from its own mapping:
    // Home > TP Calculation Manager > Segment Data Tables > <table>. Same as the Common Balance Pools list.
    // Going through TPENavigator would append to the accumulated trail and put "Custom Data Tables" in the
    // middle instead, which links back to the CLI tab rather than to this list.
    const navigateToDetail = (tableId: string) => history.push(`${tableDetailUrl}/${btoa(tableId)}`);

    const columnDefinitions = React.useMemo(() => [
        makeNameLinkColumn({ navigateToDetail, accessor: 'name', idAccessor: 'tableId', header: 'Name' }),
        {
            accessor: 'segmentTypeDisplay',
            Header: () => <div className="cell-text">Segment Type</div>,
            Cell: (e: any) => <div className="cell-text">{e.value}</div>,
        },
        {
            accessor: 'owner',
            Header: () => <div className="cell-text">Owner</div>,
            Cell: (e: any) => <div className="cell-text">{e.value}</div>,
        },
        {
            accessor: 'lastPullDisplay',
            Header: () => <div className="cell-text">Last Pull</div>,
            Cell: (e: any) => <div className="cell-text">{e.value}</div>,
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []);

    return (
        <div>
            <SegmentGrid
                className="segmentDataTablesGrid"
                loading={loading}
                data={tables}
                columnDefinitions={columnDefinitions}
                sortable={false}
                emptyMessage="No segment data tables yet."
            />
        </div>
    );
}
